import { span } from '../../../scripts/dom-builder.js';
import { COLOR_CLASS_MAP, DEFAULT_COLOR } from '../heading.constants.js';

export function applyPartialColor(headingEl, wordsToColor, wordColor) {
  if (!wordsToColor || !wordColor || wordColor === DEFAULT_COLOR) {
    return;
  }

  const colorClass = COLOR_CLASS_MAP[wordColor];
  if (!colorClass) {
    return;
  }

  const text = headingEl.textContent;
  if (!text.includes(wordsToColor)) {
    return;
  }

  const splitIndex = text.indexOf(wordsToColor);
  headingEl.textContent = '';
  if (splitIndex > 0) {
    headingEl.append(text.slice(0, splitIndex));
  }
  headingEl.append(span({ class: colorClass }, wordsToColor));
  const after = text.slice(splitIndex + wordsToColor.length);
  if (after) {
    headingEl.append(after);
  }
}
